import { Box, Stack } from "@mui/material";
import { FC } from "react";
import { ECompanyContractStatus } from "@/types/enum";
import { CompanyListTop } from "@/features/company/components/CompanyListTop";
import { CompanyTable } from "@/features/company/components/CompanyTable";

type TDuringContractCompanyListPageProps = {};

const contractStatuses = [ECompanyContractStatus.DURING_CONTRACT];

export const DuringContractCompanyListPage: FC<TDuringContractCompanyListPageProps> = () => {
  return (
    <Box>
      <Stack gap={3}>
        <CompanyListTop contractStatuses={contractStatuses} />
        <CompanyTable contractStatuses={contractStatuses} />
      </Stack>
    </Box>
  );
};
